export const PRINT_OPTIONS = [
  {
    value: 'outer-reclamation-act-parsing',
    title: 'Акт разбора'
  }
]
